import { coolerConfigFor } from '@1delta/data-sdk'
import { Call } from '../../../utils/multicall'

/**
 * User-data call build for Olympus Cooler V2. Positions are keyed by
 * ACCOUNT ADDRESS on the single monolithic MonoCooler — one position per
 * address, no sub-accounts, no discovery — so the whole read is ONE call:
 *
 *   MonoCooler.accountPosition(account)
 *     → (collateral, currentDebt, maxOriginationDebtAmount,
 *        liquidationDebtAmount, healthFactor, currentLtv, totalDelegated,
 *        numDelegateAddresses, maxDelegateAddresses)
 *
 * Every field is WAD regardless of the debt token. `healthFactor` is the
 * contract's own solvency number (vs LLTV, 1e18) and is AUTHORITATIVE —
 * liquidation here has no price trigger, so never recompute it from a
 * market price.
 */
export const COOLER_USER_CALLS = 1

export const buildCoolerUserCall = (
  chainId: string,
  lender: string,
  account: string,
): Call[] => {
  const cfg = coolerConfigFor(lender, chainId)
  if (!cfg?.monoCooler) return []
  return [
    { address: cfg.monoCooler, name: 'accountPosition', params: [account] },
  ]
}
